(function () {
  var TOP_BUCKET = 2;

  function valueMatches(min, max, selected) {
    if (selected === 'any') return true;
    var n = parseInt(selected, 10);
    if (isNaN(min) || isNaN(max)) return true;
    if (n >= TOP_BUCKET) return max >= n;
    return min <= n && n <= max;
  }

  function getSelected(scope, dimension) {
    var active = scope.querySelector('[data-sh-bedbath-filter="' + dimension + '"] .is-active');
    return active ? active.getAttribute('data-sh-bedbath-value') : 'any';
  }

  function getCards(scope) {
    return Array.prototype.map.call(scope.querySelectorAll('[data-sh-bed-min]'), function (card) {
      return {
        bedMin: parseInt(card.getAttribute('data-sh-bed-min'), 10),
        bedMax: parseInt(card.getAttribute('data-sh-bed-max'), 10),
        bathMin: parseInt(card.getAttribute('data-sh-bath-min'), 10),
        bathMax: parseInt(card.getAttribute('data-sh-bath-max'), 10),
      };
    });
  }

  function hasAnyMatch(cards, bedValue, bathValue) {
    return cards.some(function (card) {
      return valueMatches(card.bedMin, card.bedMax, bedValue) && valueMatches(card.bathMin, card.bathMax, bathValue);
    });
  }

  function applyFilters(scope) {
    if (!scope) return;
    var bedValue = getSelected(scope, 'bed');
    var bathValue = getSelected(scope, 'bath');

    scope.querySelectorAll('[data-sh-bed-min]').forEach(function (card) {
      var bedMin = parseInt(card.getAttribute('data-sh-bed-min'), 10);
      var bedMax = parseInt(card.getAttribute('data-sh-bed-max'), 10);
      var bathMin = parseInt(card.getAttribute('data-sh-bath-min'), 10);
      var bathMax = parseInt(card.getAttribute('data-sh-bath-max'), 10);
      var isMatch = valueMatches(bedMin, bedMax, bedValue) && valueMatches(bathMin, bathMax, bathValue);
      card.classList.toggle('dimmed', !isMatch);
    });
  }

  // Mobile only: float matching cards to the top of each Studios/ADUs
  // section and sink filtered-out (dimmed) ones to the bottom, instead of
  // hiding them. Keeps the full catalog visible (nothing disappears) while
  // letting a shopper reach the matching models without scrolling past a
  // run of ghosted cards first. Desktop's grid stays in fixed order.
  function reorderMobileCards(scope) {
    if (!scope || typeof scope.matches !== 'function' || !scope.matches('[data-sh-mobile-models]')) return;
    scope.querySelectorAll('.sh-nav-mobile-section').forEach(function (section) {
      var cards = Array.prototype.slice.call(section.querySelectorAll('.sh-nav-mobile-card'));
      if (!cards.length) return;
      cards
        .sort(function (a, b) {
          return (a.classList.contains('dimmed') ? 1 : 0) - (b.classList.contains('dimmed') ? 1 : 0);
        })
        .forEach(function (card) {
          section.appendChild(card);
        });
    });
  }

  // Disables any pill whose selection, combined with the OTHER dimension's
  // current value, would leave zero matching models — e.g. once Bedrooms
  // is set to 0, Bathrooms=2 has no match (no 0-bed model has 2 baths) and
  // becomes unclickable rather than letting the user land on an empty grid.
  function updateAvailability(scope) {
    if (!scope) return;
    var cards = getCards(scope);
    if (!cards.length) return;
    var bedValue = getSelected(scope, 'bed');
    var bathValue = getSelected(scope, 'bath');

    scope.querySelectorAll('[data-sh-bedbath-filter="bed"] [data-sh-bedbath-value]').forEach(function (button) {
      var value = button.getAttribute('data-sh-bedbath-value');
      var enabled = value === 'any' || hasAnyMatch(cards, value, bathValue);
      button.disabled = !enabled;
      button.setAttribute('aria-disabled', String(!enabled));
    });

    scope.querySelectorAll('[data-sh-bedbath-filter="bath"] [data-sh-bedbath-value]').forEach(function (button) {
      var value = button.getAttribute('data-sh-bedbath-value');
      var enabled = value === 'any' || hasAnyMatch(cards, bedValue, value);
      button.disabled = !enabled;
      button.setAttribute('aria-disabled', String(!enabled));
    });
  }

  function resetFilters(scope) {
    if (!scope) return;
    scope.querySelectorAll('[data-sh-bedbath-filter] [data-sh-bedbath-value]').forEach(function (button) {
      button.classList.toggle('is-active', button.getAttribute('data-sh-bedbath-value') === 'any');
    });
    applyFilters(scope);
    reorderMobileCards(scope);
    updateAvailability(scope);
  }

  function findScope(el) {
    return el.closest('[data-sh-nav-mega], [data-sh-mobile-models]') || document;
  }

  function initGroup(group) {
    group.querySelectorAll('[data-sh-bedbath-value]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        group.querySelectorAll('[data-sh-bedbath-value]').forEach(function (b) {
          b.classList.toggle('is-active', b === button);
        });
        var scope = findScope(group);
        applyFilters(scope);
        reorderMobileCards(scope);
        updateAvailability(scope);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-sh-bedbath-filter]').forEach(initGroup);
    document.querySelectorAll('[data-sh-nav-mega], [data-sh-mobile-models]').forEach(updateAvailability);
  });

  // Exposed so nav-mega.js can reset the bed/bath filter back to
  // Any/Any (matching the old pill filter's reset-to-"all" behavior)
  // each time the desktop mega panel reopens.
  window.shResetBedBathFilters = resetFilters;
})();
